import { Component, HostListener, OnInit } from '@angular/core';
import { Service } from '../service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-answer',
  templateUrl: './answer.component.html',
  styleUrls: ['./answer.component.scss']
})
export class AnswerComponent implements OnInit {
  @HostListener('window:beforeunload', ['$event'])
  public onPageUnload($event: BeforeUnloadEvent) {
      $event.returnValue = true;
    
  }

  public isCollapsed = false;
  isShown:boolean=false;
  answerslist: any[];
  quizResponse: string = "Very impressive!" + '\n\n' + " Having financial stability and a strong financial plan are key to your long term well being and success." + '\n\n' + " We encourage you to regularly speak with your Financial Advisor to continue staying on top of your plan. ";
  answerIcon: boolean = true;
  toogleIcon: string = '+';
  connectWithAdvisor: string = 'Connect with your Financial Advisor';
  backgroundImg = "../../assets/mom_and_child.jpg";
  name: string = '';

  constructor( 
    public quiz: Service, 
    public router: Router,

    ) {
    // //Check if answers contain No, if it does then change the response
    // for(let i = 0; i < this.quiz.answers.length; i++){
    //      this.answerslist[this.quiz.answers[i].answer];
    //      if(this.quiz.answers[i].answer === "No"){
        
    //     }
    //     }
   }
//toogle dropdown window for answers
 toggle() {
    this.isShown = !this.isShown;

    if(this.isShown) {
      this.toogleIcon = '-';

      }
      else {
        this.toogleIcon = '+';
      }
}
ngOnInit(): void {}
onPrintReport(){
      this.router.navigateByUrl("/form");
  }
  clear(){
    var answer = confirm("You will lose your answers. Press OK to contine.");
    if(answer == true)
    {
      sessionStorage.clear();
      this.router.navigateByUrl('/home');
    }
    else{
      return false;
    }
  }

  



  



}